module.exports = __webpack_public_path__ + "assets/img/triangleIcon-bffa377a.png";